module.exports = __webpack_public_path__ + "img/0Q3A2626_L_WoodMatted_MockedUp.a1e1469a.jpg";